import React from "react";
import s from "./ScoresReport.module.scss";
import { constants } from "../../utils/utils";

export const ReportCTA: React.FC<{ address: string }> = ({ address }) => {
  const handleCtaClick = () =>
    window.open(
      `${constants.REACT_APP_MAIN_URL}/get-premium?address=${address}`,
      "_blank"
    );

  return (
    <div className={s.widgetBorder}>
      <div className={s.widgetCta}>
        <button className={s.widgetCtaButton} onClick={handleCtaClick}>
          Get your FREE full report{" "}
          <span className={s.widgetCtaButtonIcon}>→</span>
        </button>
      </div>
    </div>
  );
};
